import axios from "axios";
// Relative, not the bare "constants" specifier — see customer-ledger.service.ts
// for why (collides with @types/node's ambient "constants" module under tsc).
import { API_URL } from "../constants";
import { CustomerReservationsResponse } from "types/CustomerReservations";

export interface FetchReservationsParams {
  openOnly?: boolean;
  page?: number;
  pageSize?: number;
  /** Attaches each reservation's items (pr7-contract.md §Backend, mirroring the ledger's withLines). */
  withItems?: boolean;
}

/**
 * `GET /:companyId/customers/:customerId/reservations` (pr7-contract.md §Backend).
 */
export const fetchReservations = (
  companyId: string,
  customerId: string,
  { openOnly, page, pageSize, withItems }: FetchReservationsParams = {}
): Promise<CustomerReservationsResponse> => {
  const url = `${API_URL}/${companyId}/customers/${customerId}/reservations`;
  const params: Record<string, string> = {};
  if (openOnly) params.openOnly = "true";
  if (page) params.page = String(page);
  if (pageSize) params.pageSize = String(pageSize);
  if (withItems) params.withItems = "1";
  return axios.get(url, { params }).then((response) => response.data);
};
